import { useCallback, useEffect, useRef, useState } from 'react';
import { EMPTY_SPEAKER_TEST, HuddleSpeakerTest, supportsHuddleSpeakerSelection } from './HuddleSpeakerTest';

export function useHuddleSpeakerTest() {
  const [state, setState] = useState(EMPTY_SPEAKER_TEST);
  const controller = useRef<HuddleSpeakerTest | null>(null);
  const mounted = useRef(true);
  const [supported] = useState(supportsHuddleSpeakerSelection);
  const start = useCallback((deviceId?: string) => {
    if (!mounted.current) return Promise.resolve();
    const test = controller.current ?? (controller.current = new HuddleSpeakerTest(setState));
    return test.start(deviceId);
  }, []);
  const stop = useCallback(() => controller.current?.stop(), []);
  useEffect(() => {
    mounted.current = true;
    return () => { mounted.current = false; controller.current?.dispose(); controller.current = null; };
  }, []);
  return { ...state, supported, start, stop };
}
